import TemplateCenter from 'pages/TemplateCenter';
import { ComponentType, lazy, LazyExoticComponent, ReactNode } from 'react';
/**
 * route配置
 * path 路径
 * component 组件
 * identify 鉴权数组，根据IDENTIFY的权限判定页面是否可以方案。例如identify: [IDENTIFY.EC] 仅电商可访问此页面
 * routes 子路由，子path的上级path要保持跟父路path一致。如：父 /a,子 /a/b,/a/c
 * meta: 菜单标题和图标库
 * noMatchPath 仅配置在父路由上，用于未匹配子路由的路由跳转。
 */
export interface IRoute {
  path: string;
  component?: ComponentType<any> | LazyExoticComponent<any>;
  redirect?: string;
  identify?: string[];
  adminIds?: string[];
  routes?: IRoute[];
  meta?: {
    title: ReactNode;
    icon?: JSX.Element;
  };
  noMatchPath?: string;
}
const routes: IRoute[] = [
  {
    path: '/',
    redirect: '/center',
  },
  {
    path: '/center',
    component: TemplateCenter,
    meta: {
      title: '素材模板中心',
    },
  },
  {
    path: '/local',
    component: lazy(async () => import('pages/LocalCenter')),
    meta: {
      title: '本地素材接入',
    },
  },
  {
    path: '/productions',
    component: lazy(async () => import('pages/ProductsCenter')),
    meta: {
      title: '作品管理',
    },
  },
  {
    path: '/manage',
    adminIds: ['900015350', '11772029', '17214537', '6872251'],
    component: lazy(async () => import('pages/TemplateManage')),
    meta: {
      title: '模板管理',
    },
  },
  {
    path: '/resource',
    adminIds: ['900015350', '11772029', '17214537', '6872251'],
    component: lazy(async () => import('pages/Resource')),
    meta: {
      title: '素材管理',
    },
  },
];

const navs = routes.filter((route) => route.meta);
const literalRoutes = (lroutes: IRoute[]) => {
  const result: string[] = [];
  lroutes.forEach((route) => {
    result.push(route.path);
    if (route.routes) {
      result.push(...literalRoutes(route.routes));
    }
  });
  return result;
};
const allRouterPaths = literalRoutes(routes);

function filterAdminRouters(routes: IRoute[], accountId: string) {
  const rts = routes.filter((route) => {
    return !(route.adminIds && !route?.adminIds.includes(accountId));
  });
  return rts;
}
export { filterAdminRouters, allRouterPaths, navs, routes };
